import React, { useEffect, useState } from 'react';
import Routing from '../../utils/Routing';
import {Grid} from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import EirHandsetCard from '../eir-handset-card/EirHandsetCard';
import EirPrepayPhoneToggle from '../eir-prepay-phone-toggle/EirPrepayPhoneToggle';
import EirDropdownList from '../dropdown-list/DropdownList';
import EirSelectedPlanDetails from '../eir-selected-plan-details/EirSelectedPlanDetails';
import Loading from '../shared/Loading';
import { PREPAY_PLAN_URL } from '../eir-prepay-constants/ApplicationConstants'

function EirHandsetContainer(props){
    const[phoneDetails,setPhoneDetails]=useState([]);
    const[filterOptions,setFilterOptions]=useState([]);
    const[sortOptions,setSortOptions]=useState([]);
    const[allDevices,setAllDevices]=useState([]);
    const[curPhone,setCurPhone]=useState('All Brands');
    const[curPrice,setCurPrice]=useState('default');
    const[selectedText,setSelectedText]=useState(null);
    const[planName,setPlanName]=useState(null);
    const[changeLink,setChangeLink]=useState(null);
    const[isLoading,setIsLoading]=useState(true);
    const[selectedSort,setSelectedSort]=useState((Routing.getQueryParameter('sort') ? Routing.getQueryParameter('sort').toLowerCase() : null));
    const[selectedFilter,setSelectedFilter]=useState((Routing.getQueryParameter('filter') ? Routing.getQueryParameter('filter').toLowerCase() : null));
    const graphql = useApolloClient();
    useEffect(()=>{ 
        setIsLoading(true);
        loadData();
        setSelectedPlanDetails();
    },[])
    const loadData = async () => {
            try {              
                let catOfferId=props.catalogOfferId;
                const res = await graphql.query({
                    query: ENDPOINT.GET_DEVICE_LIST,
                    variables: { catalogOfferCode: catOfferId },
                });
                if (res.data.deviceList) {
                  setPhoneDetails(res.data.deviceList);
                  setAllDevices(res.data.deviceList);
                  setFilterOptions(getFilterOptions(res.data.deviceList));  
                  setIsLoading(false);
                }
           } catch (err) {
                console.log(err.message);
            }
        };
    const getSortOptions = () => {
        return [
          { key: 'default', value: 'Default' },
          { key: 'lth', value: 'Low to High', function: (a, b) => (a.fromPrice || a.price) - (b.fromPrice || b.price) },
          { key: 'htl', value: 'High to Low', function: (a, b) => (b.fromPrice || b.price) - (a.fromPrice || a.price) }
        ];
      }
    const getFilterOptions= (devices) => {
        var filterOptions = [{ key: 'all', value: 'All Brands', function: d => true }];
        devices.forEach(device => {
        let key = device.manufacturer.replace(/\s+/g, '').toLowerCase();
        if (filterOptions.filter(option => option.key == key).length == 0) {
            filterOptions.push({
            key: key,
            value: device.manufacturer,
            function: d => d.manufacturer == device.manufacturer
            });
        }
        });
        setSortOptions(getSortOptions());
        return filterOptions;
    }
    
    const selectFilter = (value) => {
      var sortedDevice=[];
      setCurPhone(value.value);
      if(value.value!=='All Brands'?allDevices.filter(device=>device.manufacturer===value.value).map(dev=>(
        sortedDevice.push(dev)
      )):sortedDevice=allDevices)
      setPhoneDetails(sortedDevice);
    }
    const selectPriceSort = (value) => { 
      let sortDevices=[];
      setCurPrice(value.key);
      if(value.key==='lth'){
        phoneDetails.slice().sort(function(a, b){return a.fromPrice - b.fromPrice}).map(c=>(
          sortDevices.push(c)
        ));
      }else if(value.key==='htl'){
        phoneDetails.sort(function(a, b){return b.fromPrice - a.fromPrice}).map(c=>(
          sortDevices.push(c)
        ));
      }else{
        loadData();
        if(curPhone!=='All Brands'?allDevices.filter(device=>device.manufacturer===curPhone).map(dev=>(
          sortDevices.push(dev)
        )):allDevices.map(dev=>(
          sortDevices.push(dev)
        )));
      }
      setPhoneDetails(sortDevices);
    }
    const setSelectedPlanDetails =() => {
      setSelectedText('Selected Plan:');
      setPlanName(localStorage.getItem('plan-name'));
      setChangeLink(PREPAY_PLAN_URL);
  };
  if(isLoading)  {
    return(<Loading className="m-5" />);
  }else{
    return (        
      <Grid xs={6} sm={12} className='handset-container-root'>            
           {planName?
           <Grid container className='prepay handset-width' justify="center">
           <EirSelectedPlanDetails selectedText={selectedText} detailsText={planName} changeLink={changeLink}/>
           </Grid>
           :<EirPrepayPhoneToggle toggle='0'/>}            
          {filterOptions.length>0?<Grid container className='dropdown-filter'><div className='dropdown-sorting-margin'><EirDropdownList
            options={filterOptions}
            title="Brand"
            onClick={selectFilter}
            initialOption={filterOptions.filter(option => option.key ==selectedFilter)[0]}
            className='dropdown-sorting-margin'/></div>
          <EirDropdownList
            options={sortOptions}
            title="Price"
            onClick={selectPriceSort}
            initialOption={sortOptions.filter(option => option.key == selectedSort)[0]}
          /></Grid>:''}
          <Grid container className='container-padding'>
          {phoneDetails.map((phoneDetail, index) =>
              <EirHandsetCard
              outOfStockForm={props.outOfStockForm}
              ctaText={props.ctaText}
              key={phoneDetail.id + index}
              theme={props.theme}
              device={phoneDetail} />
            )}  
          </Grid>
      </Grid>       
  );
  }
 

}export default EirHandsetContainer;